import { getMetadata } from '~loader/loader-utils';
import slugify from 'slugify';
import Swal from 'sweetalert2';
import { makePDF } from '~core/makePDF';

export const savePDF = async () => {
  const pdf = await makePDF();
  const metadata = getMetadata();

  const fileName = slugify(
    `${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

  pdf.save(fileName);
  Swal.hideLoading();
  Swal.fire({
    title: 'Fatto!',
    html: "L'immagine &egrave; stata scaricata.",
    icon: 'success',
    confirmButtonColor: '#278e8e',
  });
};
